angular.module('leanlaw').controller('FixedFeeProfitabilitySidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", "userService", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts, userService) {
  $scope.filter = {
    include: {}
  };
  $scope.filter.include.matters = false;
  $scope.filter.include.fixedFees = false;
  // $scope.filter.include.accounting = false;

  $scope.handleCheckbox = function (filter) {
    if (filter.matters) {
      $scope.filter.include.matters = true;
      $scope.filter.include.fixedFees = false;
    } else if (!filter.matters && filter.fixedFees) {
      $scope.filter.include.matters = false;
      $scope.filter.include.fixedFees = false;
      return;
    } else if (filter.fixedFees && filter.matters) {
      $scope.filter.include.matters = true;
      $scope.filter.include.fixedFees = true;
    } else {
      $scope.filter.include.fixedFees = false;
    }
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  };

  // Fires immediately on filter creation
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);

  // $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
}]);